/**
 * @generated SignedSource<<40b44292a46cec41f45d6bc64a3bc8c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BaselineEditPageRefetchQuery$variables = {
  projectId?: string | null;
  hasDeliverablesFeature: boolean;
};
export type BaselineEditPageRefetchQuery$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"BaselineEditPage_viewer">;
  } | null;
};
export type BaselineEditPageRefetchQuery = {
  variables: BaselineEditPageRefetchQuery$variables;
  response: BaselineEditPageRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasDeliverablesFeature"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "edit_baseline"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"edit_baseline\")"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v6 = [
  (v3/*: any*/),
  (v4/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineCost",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineProfit",
  "storageKey": null
},
v10 = [
  (v3/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rate",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "convertToProjectCurrency",
    "value": true
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineMinutes",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineRevenue",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineTimeAndExpenses",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "baselineMargin",
  "storageKey": null
},
v17 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000000
  }
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v22 = [
  (v4/*: any*/),
  (v3/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "globalPhaseId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliverableId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BaselineEditPageRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "hasDeliverablesFeature",
                "variableName": "hasDeliverablesFeature"
              },
              {
                "kind": "Variable",
                "name": "projectId",
                "variableName": "projectId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "BaselineEditPage_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BaselineEditPageRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoleTypeConnection",
                "kind": "LinkedField",
                "name": "roles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ExpenseCategoryTypeConnection",
                "kind": "LinkedField",
                "name": "expenseCategories",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ExpenseCategoryTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExpenseCategory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "disabled",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "projectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customProjectId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectColor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useBaseline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineRouteAccess",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "synchBaselineAndScopingDates",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useDeliverables",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budgetType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "budget",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profile",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Quote",
                "kind": "LinkedField",
                "name": "quote",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineEstimationMinutesPerDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStartYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStartMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectStartDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "projectEndDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineTargetMinutes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineTarget",
                "storageKey": null
              },
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "baselineTargetPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "useFixedPriceForBaselineRevenue",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RateCard",
                "kind": "LinkedField",
                "name": "rateCard",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Role",
                    "kind": "LinkedField",
                    "name": "disabledRoles",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RateTypeConnection",
                    "kind": "LinkedField",
                    "name": "rates",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RateTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Rate",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "defaultRate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": (v10/*: any*/),
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v12/*: any*/),
                "concreteType": "FinancialNumbers",
                "kind": "LinkedField",
                "name": "financialNumbers",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": "financialNumbers(convertToProjectCurrency:true)"
              },
              {
                "condition": "hasDeliverablesFeature",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v17/*: any*/),
                    "concreteType": "DeliverableTypeConnection",
                    "kind": "LinkedField",
                    "name": "deliverables",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DeliverableTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DeliverableType",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "description",
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "price",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "invoicedAmount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lockedRevenue",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasBeenInvoiced",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasLockedRevenue",
                                "storageKey": null
                              },
                              (v7/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": "deliverables(first:1000000)"
                  },
                  {
                    "alias": null,
                    "args": (v17/*: any*/),
                    "filters": [],
                    "handle": "connection",
                    "key": "Project_deliverables",
                    "kind": "LinkedHandle",
                    "name": "deliverables"
                  }
                ]
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "PhaseTypeConnection",
                "kind": "LinkedField",
                "name": "phases",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sortOrder",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "startDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deadlineDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deadlineMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deadlineYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineStartDay",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineYear",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "baselineDeadlineDay",
                            "storageKey": null
                          },
                          (v18/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhasePortalConfig",
                            "kind": "LinkedField",
                            "name": "portalConfig",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "requiresClientSignoff",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "signoffApproverPortalUserId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "signoffLocked",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoleRate",
                            "kind": "LinkedField",
                            "name": "averageRatesByRole",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "roleId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "costRate",
                                "storageKey": null
                              },
                              (v11/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "condition": "hasDeliverablesFeature",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": (v21/*: any*/),
                                "concreteType": "PhaseDeliverableTypeConnection",
                                "kind": "LinkedField",
                                "name": "phaseDeliverables",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PhaseDeliverableTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "PhaseDeliverable",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "phaseId",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DeliverableType",
                                            "kind": "LinkedField",
                                            "name": "deliverable",
                                            "plural": false,
                                            "selections": (v6/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": (v12/*: any*/),
                                            "concreteType": "FinancialNumbers",
                                            "kind": "LinkedField",
                                            "name": "financialNumbers",
                                            "plural": false,
                                            "selections": [
                                              (v13/*: any*/),
                                              (v15/*: any*/),
                                              (v14/*: any*/),
                                              (v8/*: any*/),
                                              (v9/*: any*/),
                                              (v16/*: any*/)
                                            ],
                                            "storageKey": "financialNumbers(convertToProjectCurrency:true)"
                                          },
                                          (v7/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v19/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v20/*: any*/)
                                ],
                                "storageKey": "phaseDeliverables(first:10000)"
                              },
                              {
                                "alias": null,
                                "args": (v21/*: any*/),
                                "filters": [],
                                "handle": "connection",
                                "key": "Phase_phaseDeliverables",
                                "kind": "LinkedHandle",
                                "name": "phaseDeliverables"
                              }
                            ]
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": "phases(first:1000000)"
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_phases",
                "kind": "LinkedHandle",
                "name": "phases"
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "PhaseBaselineExpenseTypeConnection",
                "kind": "LinkedField",
                "name": "phaseBaselineExpenses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseBaselineExpenseTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseBaselineExpenseType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExpenseCategory",
                            "kind": "LinkedField",
                            "name": "expenseCategory",
                            "plural": false,
                            "selections": (v22/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseRevenue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseCost",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseMarkup",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "expenseProfit",
                            "storageKey": null
                          },
                          (v23/*: any*/),
                          (v24/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": "phaseBaselineExpenses(first:1000000)"
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_phaseBaselineExpenses",
                "kind": "LinkedHandle",
                "name": "phaseBaselineExpenses"
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "concreteType": "PhaseBaselineRoleTypeConnection",
                "kind": "LinkedField",
                "name": "phaseBaselineRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PhaseBaselineRoleTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PhaseBaselineRoleType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v23/*: any*/),
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": (v22/*: any*/),
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": (v12/*: any*/),
                            "concreteType": "FinancialNumbers",
                            "kind": "LinkedField",
                            "name": "financialNumbers",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v14/*: any*/),
                              (v8/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "baselineRatePerHour",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "baselineCostPerHour",
                                "storageKey": null
                              }
                            ],
                            "storageKey": "financialNumbers(convertToProjectCurrency:true)"
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": "phaseBaselineRoles(first:1000000)"
              },
              {
                "alias": null,
                "args": (v17/*: any*/),
                "filters": [],
                "handle": "connection",
                "key": "Project_phaseBaselineRoles",
                "kind": "LinkedHandle",
                "name": "phaseBaselineRoles"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3949fc761f1b6d7f14a58d3fce16ac62",
    "id": null,
    "metadata": {},
    "name": "BaselineEditPageRefetchQuery",
    "operationKind": "query",
    "text": "query BaselineEditPageRefetchQuery(\n  $projectId: String\n  $hasDeliverablesFeature: Boolean!\n) {\n  viewer {\n    component(name: \"edit_baseline\")\n    ...BaselineEditPage_viewer_48xnaJ\n    id\n  }\n}\n\nfragment BaselineEditPage_viewer_48xnaJ on Viewer {\n  id\n  company {\n    id\n    name\n    currency\n    roles {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n    expenseCategories {\n      edges {\n        node {\n          id\n          name\n          disabled\n        }\n      }\n    }\n  }\n  project(id: $projectId) {\n    ...ProjectIndicator_project\n    useBaseline\n    baselineRouteAccess\n    synchBaselineAndScopingDates\n    useDeliverables\n    budgetType\n    budget\n    id\n    stage {\n      __typename\n      id\n      name\n      profile\n    }\n    companyProjectId\n    customProjectId\n    quote {\n      id\n      status\n    }\n    projectColor\n    name\n    baselineEstimationMinutesPerDay\n    projectStartYear\n    projectStartMonth\n    projectStartDay\n    projectEndYear\n    projectEndMonth\n    projectEndDay\n    baselineTargetMinutes\n    baselineTarget\n    baselineCost\n    baselineProfit\n    baselineTargetPrice\n    useFixedPriceForBaselineRevenue\n    rateCard {\n      id\n      currency\n      disabledRoles {\n        id\n      }\n      rates {\n        edges {\n          node {\n            rate\n            defaultRate\n            role {\n              id\n            }\n            id\n          }\n        }\n      }\n    }\n    financialNumbers(convertToProjectCurrency: true) {\n      baselineMinutes\n      baselineRevenue\n      baselineTimeAndExpenses\n      baselineCost\n      baselineProfit\n      baselineMargin\n    }\n    deliverables(first: 1000000) @include(if: $hasDeliverablesFeature) {\n      edges {\n        node {\n          id\n          name\n          description\n          projectId\n          price\n          invoicedAmount\n          lockedRevenue\n          hasBeenInvoiced\n          hasLockedRevenue\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    phases(first: 1000000) {\n      edges {\n        node {\n          id\n          name\n          sortOrder\n          startYear\n          startMonth\n          startDay\n          deadlineDay\n          deadlineMonth\n          deadlineYear\n          baselineStartYear\n          baselineStartMonth\n          baselineStartDay\n          baselineDeadlineYear\n          baselineDeadlineMonth\n          baselineDeadlineDay\n          projectId\n          portalConfig {\n            requiresClientSignoff\n            signoffApproverPortalUserId\n            signoffLocked\n          }\n          averageRatesByRole {\n            roleId\n            costRate\n            rate\n          }\n          phaseDeliverables(first: 10000) @include(if: $hasDeliverablesFeature) {\n            edges {\n              node {\n                id\n                phaseId\n                deliverable {\n                  id\n                  name\n                }\n                financialNumbers(convertToProjectCurrency: true) {\n                  baselineMinutes\n                  baselineTimeAndExpenses\n                  baselineRevenue\n                  baselineCost\n                  baselineProfit\n                  baselineMargin\n                }\n                __typename\n              }\n              cursor\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    phaseBaselineExpenses(first: 1000000) {\n      edges {\n        node {\n          id\n          expenseName\n          expenseCategory {\n            name\n            id\n          }\n          expenseRevenue\n          expenseCost\n          expenseMarkup\n          expenseProfit\n          globalPhaseId\n          deliverableId\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    phaseBaselineRoles(first: 1000000) {\n      edges {\n        node {\n          id\n          globalPhaseId\n          deliverableId\n          role {\n            name\n            id\n          }\n          baselineMinutes\n          financialNumbers(convertToProjectCurrency: true) {\n            baselineTimeAndExpenses\n            baselineRevenue\n            baselineCost\n            baselineProfit\n            baselineRatePerHour\n            baselineCostPerHour\n          }\n          __typename\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n  }\n}\n\nfragment ProjectIndicator_project on ProjectType {\n  name\n  companyProjectId\n  customProjectId\n  projectColor\n}\n"
  }
};
})();

(node as any).hash = "34fab2a2f153dc420d2cc63bc02d6056";

export default node;
